import firebase from 'firebase/app';
import db from '../firebaseInit';

const incrementGlobalAppStat = (fieldName, incrementBy = 1) => {
  const increment = firebase.firestore.FieldValue.increment(incrementBy);
  db.collection('global')
    .doc('appStats')
    .update({[fieldName]: increment});
};

export default incrementGlobalAppStat;
